<template>
    <base-modal @close="$emit('close')"  v-if="team_id" title="Members" :visible="visible">
        <team-members :team_id="team_id" :show_title="false"/><br/>

        <base-button @click="$emit('close')" icon="fas fa-check" class="is-primary">
            {{button}}
        </base-button>
    </base-modal>
</template>

<script>
import TeamMembers from './TeamMembers.vue';

export default {
    name: 'TeamMembersModal',
    components: { TeamMembers },
    props: {
        visible: Boolean,
        team_id: { type: Number, default: null },
        button: { type: String, default: 'Close' },
    },
};
</script>
